import { z } from 'zod';
/** Locales the CMS authors content in. `en` is the source of truth and the fallback. */
export const LOCALES = ['en', 'ar'];
export const DEFAULT_LOCALE = 'en';
export const localeSchema = z.enum(LOCALES);
/**
 * A translatable string. `en` is required so nothing can be authored without a
 * fallback; `ar` may be left blank while a translation is pending, and the
 * publisher falls back to `en` for that locale.
 */
export const localizedStringSchema = z.object({
    en: z.string().trim().min(1, 'English text is required').max(4000),
    ar: z.string().trim().max(4000).default(''),
});
/** Same as {@link localizedStringSchema} but the whole field may be omitted. */
export const optionalLocalizedStringSchema = z.object({
    en: z.string().trim().max(4000).default(''),
    ar: z.string().trim().max(4000).default(''),
});
/** Resolve a localized value for one locale, falling back to English when blank. */
export function pickLocale(value, locale) {
    if (!value)
        return '';
    const candidate = value[locale];
    if (candidate && candidate.trim().length > 0)
        return candidate;
    return value[DEFAULT_LOCALE] ?? '';
}
export function isRtl(locale) {
    return locale === 'ar';
}
//# sourceMappingURL=i18n.js.map